/** 表头默认预留高度（px），DOM 未渲染时回退 */
export const TABLE_HEADER_RESERVE = 40;

/** 分页区默认预留高度（含 margin，px） */
export const TABLE_PAGINATION_RESERVE = 52;

/** scroll.y 最小值（px） */
export const TABLE_MIN_SCROLL_Y = 200;

/** 容器高度低于此值时不计算 scroll.y（父级未约束高度） */
export const TABLE_FILL_MIN_CONTAINER = 80;
